module.exports = {
	CommandsToClient: {
		FatalError: 0,
		0: 'FatalError',
		SetClientId: 1,
		1: 'SetClientId',
		SetClientIdToData: 2,
		2: 'SetClientIdToData',
		SetGameState: 3,
		3: 'SetGameState',
		SetGameBoardCell: 4,
		4: 'SetGameBoardCell',
		SetGameBoard: 5,
		5: 'SetGameBoard',
		SetScoreSheetCell: 6,
		6: 'SetScoreSheetCell',
		SetScoreSheet: 7,
		7: 'SetScoreSheet',
		SetGamePlayerJoin: 8,
		8: 'SetGamePlayerJoin',
		SetGamePlayerRejoin: 9,
		9: 'SetGamePlayerRejoin',
		SetGamePlayerLeave: 10,
		10: 'SetGamePlayerLeave',
		SetGamePlayerJoinMissing: 11,
		11: 'SetGamePlayerJoinMissing',
		SetGameWatcherClientId: 12,
		12: 'SetGameWatcherClientId',
		ReturnWatcherToLobby: 13,
		13: 'ReturnWatcherToLobby',
		AddGameHistoryMessage: 14,
		14: 'AddGameHistoryMessage',
		AddGameHistoryMessages: 15,
		15: 'AddGameHistoryMessages',
		SetTurn: 16,
		16: 'SetTurn',
		SetGameAction: 17,
		17: 'SetGameAction',
		SetTile: 18,
		18: 'SetTile',
		SetTileGameBoardType: 19,
		19: 'SetTileGameBoardType',
		RemoveTile: 20,
		20: 'RemoveTile',
		AddGlobalChatMessage: 21,
		21: 'AddGlobalChatMessage',
		AddGameChatMessage: 22,
		22: 'AddGameChatMessage',
		DestroyGame: 23,
		23: 'DestroyGame'
	},
	CommandsToServer: {
		CreateGame: 0,
		0: 'CreateGame',
		JoinGame: 1,
		1: 'JoinGame',
		RejoinGame: 2,
		2: 'RejoinGame',
		WatchGame: 3,
		3: 'WatchGame',
		LeaveGame: 4,
		4: 'LeaveGame',
		DoGameAction: 5,
		5: 'DoGameAction',
		SendGlobalChatMessage: 6,
		6: 'SendGlobalChatMessage',
		SendGameChatMessage: 7,
		7: 'SendGameChatMessage'
	},
	Errors: {
		NotUsingLatestVersion: 0,
		0: 'NotUsingLatestVersion',
		GenericError: 1,
		1: 'GenericError',
		InvalidUsername: 2,
		2: 'InvalidUsername',
		InvalidPassword: 3,
		3: 'InvalidPassword',
		MissingPassword: 4,
		4: 'MissingPassword',
		ProvidedPassword: 5,
		5: 'ProvidedPassword',
		IncorrectPassword: 6,
		6: 'IncorrectPassword',
		NonMatchingPasswords: 7,
		7: 'NonMatchingPasswords',
		ExistingPassword: 8,
		8: 'ExistingPassword',
		UsernameAlreadyInUse: 9,
		9: 'UsernameAlreadyInUse',
		LostConnection: 10,
		10: 'LostConnection'
	},
	GameActions: {
		StartGame: 0,
		0: 'StartGame',
		PlayTile: 1,
		1: 'PlayTile',
		SelectNewChain: 2,
		2: 'SelectNewChain',
		SelectMergerSurvivor: 3,
		3: 'SelectMergerSurvivor',
		SelectChainToDisposeOfNext: 4,
		4: 'SelectChainToDisposeOfNext',
		DisposeOfShares: 5,
		5: 'DisposeOfShares',
		PurchaseShares: 6,
		6: 'PurchaseShares',
		GameOver: 7,
		7: 'GameOver'
	},
	GameBoardTypes: {
		Luxor: 0,
		0: 'Luxor',
		Tower: 1,
		1: 'Tower',
		American: 2,
		2: 'American',
		Festival: 3,
		3: 'Festival',
		Worldwide: 4,
		4: 'Worldwide',
		Continental: 5,
		5: 'Continental',
		Imperial: 6,
		6: 'Imperial',
		Nothing: 7,
		7: 'Nothing',
		NothingYet: 8,
		8: 'NothingYet',
		CantPlayEver: 9,
		9: 'CantPlayEver',
		IHaveThis: 10,
		10: 'IHaveThis',
		WillPutLonelyTileDown: 11,
		11: 'WillPutLonelyTileDown',
		HaveNeighboringTileToo: 12,
		12: 'HaveNeighboringTileToo',
		WillFormNewChain: 13,
		13: 'WillFormNewChain',
		WillMergeChains: 14,
		14: 'WillMergeChains',
		CantPlayNow: 15,
		15: 'CantPlayNow',
		Max: 16,
		16: 'Max'
	},
	GameHistoryMessages: {
		TurnBegan: 0,
		0: 'TurnBegan',
		DrewPositionTile: 1,
		1: 'DrewPositionTile',
		StartedGame: 2,
		2: 'StartedGame',
		DrewTile: 3,
		3: 'DrewTile',
		HasNoPlayableTile: 4,
		4: 'HasNoPlayableTile',
		PlayedTile: 5,
		5: 'PlayedTile',
		FormedChain: 6,
		6: 'FormedChain',
		MergedChains: 7,
		7: 'MergedChains',
		SelectedMergerSurvivor: 8,
		8: 'SelectedMergerSurvivor',
		SelectedChainToDisposeOfNext: 9,
		9: 'SelectedChainToDisposeOfNext',
		ReceivedBonus: 10,
		10: 'ReceivedBonus',
		DisposedOfShares: 11,
		11: 'DisposedOfShares',
		CouldNotAffordAnyShares: 12,
		12: 'CouldNotAffordAnyShares',
		PurchasedShares: 13,
		13: 'PurchasedShares',
		DrewLastTile: 14,
		14: 'DrewLastTile',
		ReplacedDeadTile: 15,
		15: 'ReplacedDeadTile',
		EndedGame: 16,
		16: 'EndedGame',
		NoTilesPlayedForEntireRound: 17,
		17: 'NoTilesPlayedForEntireRound',
		AllTilesPlayed: 18,
		18: 'AllTilesPlayed'
	},
	GameModes: {
		Singles: 0,
		0: 'Singles',
		Teams: 1,
		1: 'Teams',
		Max: 2,
		2: 'Max'
	},
	GameStates: {
		Starting: 0,
		0: 'Starting',
		StartingFull: 1,
		1: 'StartingFull',
		InProgress: 2,
		2: 'InProgress',
		Completed: 3,
		3: 'Completed'
	},
	Notifications: {
		GameFull: 0,
		0: 'GameFull',
		GameStarted: 1,
		1: 'GameStarted',
		YourTurn: 2,
		2: 'YourTurn',
		GameOver: 3,
		3: 'GameOver'
	},
	Options: {
		EnablePageTitleNotifications: 0,
		0: 'EnablePageTitleNotifications',
		Sound: 1,
		1: 'Sound',
		Volume: 2,
		2: 'Volume',
		EnableHighContrastColors: 3,
		3: 'EnableHighContrastColors',
		EnableTextBackgroundColors: 4,
		4: 'EnableTextBackgroundColors',
		ColorScheme: 5,
		5: 'ColorScheme',
		GameBoardLabelMode: 6,
		6: 'GameBoardLabelMode'
	},
	PubSub: {
		Server_FatalError: 0,
		0: 'Server_FatalError',
		Server_SetClientId: 1,
		1: 'Server_SetClientId',
		Server_SetClientIdToData: 2,
		2: 'Server_SetClientIdToData',
		Server_SetGameState: 3,
		3: 'Server_SetGameState',
		Server_SetGameBoardCell: 4,
		4: 'Server_SetGameBoardCell',
		Server_SetGameBoard: 5,
		5: 'Server_SetGameBoard',
		Server_SetScoreSheetCell: 6,
		6: 'Server_SetScoreSheetCell',
		Server_SetScoreSheet: 7,
		7: 'Server_SetScoreSheet',
		Server_SetGamePlayerJoin: 8,
		8: 'Server_SetGamePlayerJoin',
		Server_SetGamePlayerRejoin: 9,
		9: 'Server_SetGamePlayerRejoin',
		Server_SetGamePlayerLeave: 10,
		10: 'Server_SetGamePlayerLeave',
		Server_SetGamePlayerJoinMissing: 11,
		11: 'Server_SetGamePlayerJoinMissing',
		Server_SetGameWatcherClientId: 12,
		12: 'Server_SetGameWatcherClientId',
		Server_ReturnWatcherToLobby: 13,
		13: 'Server_ReturnWatcherToLobby',
		Server_AddGameHistoryMessage: 14,
		14: 'Server_AddGameHistoryMessage',
		Server_AddGameHistoryMessages: 15,
		15: 'Server_AddGameHistoryMessages',
		Server_SetTurn: 16,
		16: 'Server_SetTurn',
		Server_SetGameAction: 17,
		17: 'Server_SetGameAction',
		Server_SetTile: 18,
		18: 'Server_SetTile',
		Server_SetTileGameBoardType: 19,
		19: 'Server_SetTileGameBoardType',
		Server_RemoveTile: 20,
		20: 'Server_RemoveTile',
		Server_AddGlobalChatMessage: 21,
		21: 'Server_AddGlobalChatMessage',
		Server_AddGameChatMessage: 22,
		22: 'Server_AddGameChatMessage',
		Server_DestroyGame: 23,
		23: 'Server_DestroyGame',
		Client_AddClient: 24,
		24: 'Client_AddClient',
		Client_AddGameWatcher: 25,
		25: 'Client_AddGameWatcher',
		Client_AddLobbyClient: 26,
		26: 'Client_AddLobbyClient',
		Client_InitializationComplete: 27,
		27: 'Client_InitializationComplete',
		Client_JoinGame: 28,
		28: 'Client_JoinGame',
		Client_LeaveGame: 29,
		29: 'Client_LeaveGame',
		Client_RemoveClient: 30,
		30: 'Client_RemoveClient',
		Client_RemoveGameWatcher: 31,
		31: 'Client_RemoveGameWatcher',
		Client_RemoveLobbyClient: 32,
		32: 'Client_RemoveLobbyClient',
		Client_Resize: 33,
		33: 'Client_Resize',
		Client_SetClientData: 34,
		34: 'Client_SetClientData',
		Client_SetGamePlayerData: 35,
		35: 'Client_SetGamePlayerData',
		Client_SetGamePlayerJoin: 36,
		36: 'Client_SetGamePlayerJoin',
		Client_SetGamePlayerJoinMissing: 37,
		37: 'Client_SetGamePlayerJoinMissing',
		Client_SetGamePlayerLeave: 38,
		38: 'Client_SetGamePlayerLeave',
		Client_SetGamePlayerRejoin: 39,
		39: 'Client_SetGamePlayerRejoin',
		Client_SetGameState: 40,
		40: 'Client_SetGameState',
		Client_SetOption: 41,
		41: 'Client_SetOption',
		Client_SetPage: 42,
		42: 'Client_SetPage',
		Network_Disconnect: 43,
		43: 'Network_Disconnect',
		Network_MessageProcessingComplete: 44,
		44: 'Network_MessageProcessingComplete',
		Max: 45,
		45: 'Max'
	},
	ScoreSheetIndexes: {
		Luxor: 0,
		0: 'Luxor',
		Tower: 1,
		1: 'Tower',
		American: 2,
		2: 'American',
		Festival: 3,
		3: 'Festival',
		Worldwide: 4,
		4: 'Worldwide',
		Continental: 5,
		5: 'Continental',
		Imperial: 6,
		6: 'Imperial',
		Cash: 7,
		7: 'Cash',
		Net: 8,
		8: 'Net',
		Username: 9,
		9: 'Username',
		PositionTile: 10,
		10: 'PositionTile',
		Client: 11,
		11: 'Client'
	},
	ScoreSheetRows: {
		Player0: 0,
		0: 'Player0',
		Player1: 1,
		1: 'Player1',
		Player2: 2,
		2: 'Player2',
		Player3: 3,
		3: 'Player3',
		Player4: 4,
		4: 'Player4',
		Player5: 5,
		5: 'Player5',
		Available: 6,
		6: 'Available',
		ChainSize: 7,
		7: 'ChainSize',
		Price: 8,
		8: 'Price'
	}
};



//////////////////
// WEBPACK FOOTER
// ./client/main/js/enums.js
// module id = 3
// module chunks = 0